import { hexToRgb } from '@shared-lib/utils/chart-utils/modify-hex-color';
import { generateColorScale } from '@shared-lib/utils/colors/generate-color-scale';

export const applySignUpBrandingColors = (primaryColor: string): void => {
  const rgb = hexToRgb(primaryColor);
  const colorScale = generateColorScale(primaryColor);

  document.documentElement.style.setProperty('--color-primary-rgb', `${rgb?.r}, ${rgb?.g}, ${rgb?.b}`);
  document.documentElement.style.setProperty('--primary', `#${primaryColor}`);
  document.documentElement.style.setProperty('--color-primary-50', `${colorScale[50]}`);
  document.documentElement.style.setProperty('--color-primary-100', `${colorScale[100]}`);
  document.documentElement.style.setProperty('--color-primary-200', `${colorScale[200]}`);
  document.documentElement.style.setProperty('--color-primary-700', `${colorScale[700]}`);
};
